<template>
  <div class="d-flex flex-column flex-root">
    <!--begin::Page-->
    <div class="page d-flex flex-row flex-column-fluid">
      <!--begin::Aside-->
      <!--end::Aside-->
      <!--begin::Wrapper-->
      <div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
        <!--begin::Header-->
        <div id="kt_header" class="header">
          <!--begin::Container-->
          <div
              class="container-fluid d-flex align-items-center flex-wrap justify-content-between"
              id="kt_header_container"
          >
            <!--begin::Page title-->
            <div
                class="page-title d-flex flex-column align-items-start justify-content-center flex-wrap me-2 pb-5 pb-lg-0 pt-7 pt-lg-0"
                data-kt-swapper="true"
                data-kt-swapper-mode="prepend"
                data-kt-swapper-parent="{default: '#kt_content_container', lg: '#kt_header_container'}"
            >
              <!--begin::Heading-->
              <h1 class="d-flex flex-column text-dark fw-bolder my-0">
                Danh sách bình luận
                <small class="text-muted fs-6 fw-bold ms-1 pt-1"
                >Số lượng {{ $numberFormat(items.metaData?.total) }}</small
                >
              </h1>
              <!--end::Heading-->
            </div>
            <!--end::Page title=-->
            <!--begin::Wrapper-->
            <div class="d-flex d-lg-none align-items-center ms-n3 me-2">
              <!--begin::Aside mobile toggle-->
              <div
                  class="btn btn-icon btn-active-icon-primary"
                  id="kt_aside_toggle"
              >
                <!--begin::Svg Icon | path: icons/duotune/abstract/abs015.svg-->
                <span class="svg-icon svg-icon-1 mt-1">
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                  >
                    <path
                        d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
                        fill="black"
                    />
                    <path
                        opacity="0.3"
                        d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
                        fill="black"
                    />
                  </svg>
                </span>
                <!--end::Svg Icon-->
              </div>
              <!--end::Aside mobile toggle-->
            </div>
            <!--end::Wrapper-->
          </div>
          <!--end::Container-->
        </div>
        <!--end::Header-->
        <!--begin::Content-->
        <div
            class="content d-flex flex-column flex-column-fluid"
            id="kt_content"
        >
          <!--begin::Container-->
          <div class="container-fluid" id="kt_content_container">
            <!--begin::Row-->
            <div class="row g-5 g-lg-10">
              <div class="card card-flush">
                <!--begin::Card body-->
                <div class="card-body pt-0">
                  <!--begin::Table-->
                  <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder">
                    <!--begin::Nav item-->
                    <!--end::Nav item-->
                    <!--begin::Nav item-->
                    <li class="nav-item mt-2">
                      <a
                          class="nav-link text-active-primary ms-0 me-10 py-5 cursor-pointer"
                          :class="tabActive === 'COMMENT' ? 'active' : ''"
                          @click="activeTab('COMMENT')"
                      >Bình luận</a
                      >
                    </li>
                    <li class="nav-item mt-2">
                      <a
                          class="nav-link text-active-primary ms-0 me-10 py-5 cursor-pointer"
                          :class="tabActive === 'REPORT' ? 'active' : ''"
                          @click="activeTab('REPORT')"
                      >Báo cáo</a
                      >
                    </li>
                    <!--end::Nav item-->
                  </ul>
                  <div id="kt_ecommerce_category_table_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                    <div class="table-responsive">
                      <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">

                        <thead v-if="tabActive === 'COMMENT'">
                        <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                          <th class="w-10px pe-2">ID</th>
                          <th class="text-start">Người viết</th>
                          <th class="text-start">Bình luận</th>
                          <th class="text-center">Truyện</th>
                          <th class="text-center">Thời gian</th>
                          <th class="text-end">Hành động</th>
                        </tr>
                        </thead>

                        <thead v-if="tabActive === 'REPORT'">
                        <tr class="text-start text-danger fw-bolder fs-7 text-uppercase gs-0">
                          <th class="w-10px pe-2">ID</th>

                          <th class="text-start min-w-150px">Người viết</th>

                          <th class="text-start min-w-100px">Người báo cáo</th>

                          <th class="text-start min-w-125px">Lý do vi phạm</th>

                          <th class="text-start min-w-200px">Nội dung bị báo cáo</th>

                          <th class="text-center">Trạng thái</th>

                          <th class="text-end min-w-100px">Hành động</th>
                        </tr>
                        </thead>

                        <tbody v-if="tabActive === 'COMMENT'" class="fw-bold text-gray-600">
                        <tr v-for="(item, index) in items.data" :key="'comment-'+index">
                          <td>{{ item.id }}</td>
                          <td>
                            <UserCard :user="item.user"/>
                          </td>
                          <td style="width: 30%">{{ item.content }}</td>
                          <td class="text-center">
                            <a :href="$webUrl(item.story?.slug, item.story?.id || item.storyId)" target="_blank">
                              {{ item.story?.name || 'Xem truyện' }}
                            </a>
                          </td>
                          <td class="text-center">{{ $formatDateTime(item.createdAt) }}</td>
                          <td class="text-end">
                            <button class="btn btn-sm btn-danger" @click="removeItem(item.id)">
                              <i class="bi bi-trash"></i>
                            </button>
                          </td>
                        </tr>
                        </tbody>

                        <tbody v-if="tabActive === 'REPORT'" class="fw-bold text-gray-600">
                        <tr v-for="(report, index) in reports.data" :key="'report-' + index">
                          <template v-if="report && report.comment">
                            <td>
                              <div class="form-check form-check-sm form-check-custom form-check-solid">
                                {{ report.commentId }}
                              </div>
                            </td>

                            <td>
                              <div class="d-flex align-items-center">
                                <UserCard :user="report.comment.user" />
                              </div>
                            </td>

                            <td>
                              <div class="d-flex flex-wrap gap-1">
          <span v-for="uId in report.userIds" :key="uId" class="badge badge-light-dark">
            ID: {{ uId }}
          </span>
                              </div>
                            </td>

                            <td>
                              <div v-for="(reason, rIdx) in report.reasons" :key="rIdx">
                                <span class="badge badge-light-danger fs-8">{{ reason }}</span>
                              </div>
                            </td>

                            <td style="width: 25%">
                              <div class="text-gray-800 fw-normal text-truncate-2" :title="report.comment.content">
                                {{ report.comment.content }}
                              </div>
                            </td>

                            <td class="text-center">
                              <span v-if="report.state === 'PENDING'" class="badge badge-light-warning">Chờ xử lý</span>
                              <span v-else class="badge badge-light-success">Đã xong</span>
                            </td>

                            <td class="text-end">
                              <button class="btn btn-light-primary btn-sm me-2" @click="handleReport('REJECT', report.commentId)" title="Duyệt">
                                Gỡ vi phạm
                              </button>
                              <button class="btn btn-light-danger btn-sm" @click="handleReport('OK',report.commentId)" title="Xóa comment vi phạm">
                                Vi phạm
                              </button>
                            </td>
                          </template>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!--end::Table-->
                </div>
                <!--end::Card body-->
              </div>
            </div>
          </div>
          <!--end::Container-->
        </div>
        <!--end::Content-->
      </div>
      <!--end::Wrapper-->
    </div>
    <!--end::Page-->
  </div>
</template>
<script>
import requestUtil from "@/utils/request-util";
import UserCard from "@/components/commons/UserCard.vue";

export default {
  name: "CommentList",
  components: {UserCard},
  computed: {},
  data() {
    return {
      tabActive: 'COMMENT',
      items: {
        data: [],
        metaData: {},
      },
      reports: {
        data: [],
        metaData: {},
      },
      modalShow: false,
      dataForm: {},
      loading: {
        page: false,
        user: false,
      },
    };
  },
  mounted() {
    this.fetchItems();
  },
  created() {
  },
  methods: {
    async fetchItems() {
      const response = await requestUtil.get("/comment/_admin");
      if (response.status === 200) {
        this.items = response.data;
      }
    },
    activeTab(value) {
      this.tabActive = value;
      if (value === 'COMMENT') {
        this.fetchItems();
      } else {
        this.fetchCommentReport();
      }
    },
    async fetchCommentReport() {
      const response = await requestUtil.get("/comment/reports");
      if (response.status === 200) {
        this.reports = response.data;
      }
    },
    async handleReport(state, commentId) {
      const response = await requestUtil.post("/comment/"+commentId+"/reports?state=" + state);
      if (response.status === 200) {
        this.$notify({
          title: "Thành công",
          type: "success",
        });
      }
    },
    async removeItem(id) {
      const confirmed = window.confirm(
          "Are you sure you want to delete this item? " + id
      );
      if (confirmed) {
        const response = await requestUtil.post(
            "/comment/" + id + "/delete/_admin"
        );
        if (response.status === 200) {
          this.$notify({
            title: "Thành công",
            type: "success",
          });
          this.fetchItems();
        } else {
          this.$notify({
            title: response.data.message,
            type: "error",
          });
        }
      }
    },

  },
};
</script>
<style></style>
